import { type Hash } from 'history';
import { router } from 'src/core/Router';

import { COMPLETE_ACCOUNT_PATH, VERIFICATION_EMAIL_PATH } from '../../../core/paths/paths';
import TokenLoginResource from '../change-password-plugin/TokenLoginResource';

import verifySignupMatcher from './verifySignupMatcher';

function verifySignupPluginCreator(hash: Hash): () => Promise<unknown> {
  const params = verifySignupMatcher(hash);
  return async function verifySignupPlugin(): Promise<unknown> {
    if (!params?.token) {
      return Promise.reject();
    }

    const navigateToExpired = () => {
      router.navigate(VERIFICATION_EMAIL_PATH, {
        replace: true,
        state: { tokenExpired: true, email: params.email },
      });
    };

    try {
      const session = await TokenLoginResource.login(params.token);
      if (!session) {
        navigateToExpired();
        return Promise.reject();
      }
      router.navigate(COMPLETE_ACCOUNT_PATH, { replace: true });
      return { name: 'VERIFY_SIGNUP', session };
    } catch {
      navigateToExpired();
      return Promise.reject();
    }
  };
}

export default verifySignupPluginCreator;
